import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { HelperClasses, UIKits } from "../../../Constants/Constants";
import BorderStyles from "./BorderStyles/BorderStyles";
import BordersAndDisplays from "./BordersAndDisplays/BordersAndDisplays";
import BackgroundColors from "./BackgroundColors/BackgroundColors";
import BorderColor from "./BorderColor";
import ImageSize from "./ImageSize";
import FontStyle from "./FontStyle";
import FontWeight from "./FontWeight";
import TextColors from "./TextColors";
import Padding from "./Padding";
import OneSidePadding from "./OneSidePadding";
import Margin from "./Margin";
import OneSideMargin from "./OneSideMargin";
import FontSize from "./FontSize";
import { Fragment } from "react/jsx-runtime";
import DashedBorder from "./DashedBorder";
import DottedBorder from "./DottedBorder";
import GrooveBorder from "./GrooveBorder";
import RidgeBorder from "./RidgeBorder";

const HelperClassContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={HelperClasses} parent={UIKits} />
      <Container fluid>
        <Row>
          <BorderStyles />
          <BordersAndDisplays />
          <BackgroundColors />
          <BorderColor />
          <ImageSize />
          <FontStyle />
          <FontWeight />
          <TextColors />
          <Padding />
          <DashedBorder />
          <DottedBorder />
          <GrooveBorder />
          <RidgeBorder />
          <OneSidePadding />
          <Margin />
          <OneSideMargin />
          <FontSize />
        </Row>
      </Container>
    </Fragment>
  );
};
export default HelperClassContainer;
